<template>
  <!-- <ul class="group">
    <li class="item" v-for="item of numList" :key="item" @click="selectNum(item)">{{ item }}</li>
  </ul> -->
  <div class="group">
    <van-row gutter="5" style="margin-top: 1.33333vw">
      <van-col span="8" @click="selectNum(1)"><div class="item">1</div></van-col>
      <van-col span="8" @click="selectNum(2)"><div class="item">2</div></van-col>
      <van-col span="8" @click="selectNum(3)"><div class="item">3</div></van-col>
    </van-row>
    <van-row gutter="10" style="margin-top: 1.33333vw">
      <van-col span="8" @click="selectNum(4)"><div class="item">4</div></van-col>
      <van-col span="8" @click="selectNum(5)"><div class="item">5</div></van-col>
      <van-col span="8" @click="selectNum(6)"><div class="item">6</div></van-col>
    </van-row>
    <van-row gutter="10" style="margin-top: 1.33333vw">
      <van-col span="8" @click="selectNum(7)"><div class="item">7</div></van-col>
      <van-col span="8" @click="selectNum(8)"><div class="item">8</div></van-col>
      <van-col span="8" @click="selectNum(9)"><div class="item">9</div></van-col>
    </van-row>
    <van-row style="margin-top: 1.33333vw">
      <van-col span="24" @click="selectNum(0)"><div class="item">0</div></van-col>
    </van-row>
  </div>
</template>

<script setup>
import { defineEmits } from 'vue';
// const numList = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 0]);

const emit = defineEmits(['onSelectNumItem']);
const selectNum = (num) => {
  emit('onSelectNumItem', num);
};
</script>

<style lang="scss" scoped>
.group {
  padding: 10px;
  box-sizing: border-box;
  .item {
    width: 100%;
    display: block;
    background-color: #f8efff;
    height: 75px;
    text-align: center;
    line-height: 75px;
    border-radius: 8px;
    box-shadow: 0 2px #e5e5e5;
  }
}
</style>
